/**
 * Gemeinsame Konstanten und Helfer fuer das TODO-Modul.
 */

/** Prioritaetsstufen mit Sortierrang (0 = wichtigste) und Badge-Styling. */
export const PRIORITAETEN = Object.freeze([
  { key: 'HOCH', label: 'Hoch', rang: 0, badge: 'bg-rose-500/10 text-rose-700 ring-rose-500/25' },
  { key: 'MITTEL', label: 'Mittel', rang: 1, badge: 'bg-amber-500/10 text-amber-700 ring-amber-500/25' },
  { key: 'NIEDRIG', label: 'Niedrig', rang: 2, badge: 'bg-sky-500/10 text-sky-700 ring-sky-500/25' },
]);

/** Farbauswahl fuer Kategorien (Tailwind-500er als Hex). */
export const FARB_PALETTE = Object.freeze([
  '#ef4444', '#f97316', '#f59e0b', '#eab308', '#84cc16', '#22c55e',
  '#14b8a6', '#06b6d4', '#3b82f6', '#6366f1', '#8b5cf6', '#ec4899',
]);

/** Liefert die Metadaten einer Prioritaet (Fallback: MITTEL). */
export const prioMeta = (key) =>
  PRIORITAETEN.find((p) => p.key === key) || PRIORITAETEN[1];

/** Kategorie-Objekt zu einer numerischen id finden. */
export const findeKategorie = (kategorien, kategorieId) =>
  kategorien.find((k) => k.id === kategorieId) || null;

/** Eine offene Aufgabe ist ueberfaellig, wenn ihr Faelligkeitsdatum vor heute liegt. */
export const istUeberfaellig = (todo) => {
  if (todo.erledigt || !todo.faelligkeitsdatum) return false;
  return todo.faelligkeitsdatum < heuteIso();
};

/** Heutiges Datum als ISO-String (YYYY-MM-DD, lokale Zeit). */
export const heuteIso = () => {
  const d = new Date();
  const monat = String(d.getMonth() + 1).padStart(2, '0');
  const tag = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${monat}-${tag}`;
};

/** Formatiert ein ISO-Datum (YYYY-MM-DD) als deutsches Datum. */
export const formatDatum = (iso) => {
  if (!iso) return null;
  const [jahr, monat, tag] = iso.split('-');
  return `${tag}.${monat}.${jahr}`;
};

/** Sortiert Aufgaben: offene zuerst, dann nach Faelligkeit (leer zuletzt) und Prioritaet. */
export const sortTodos = (todos) =>
  [...todos].sort((a, b) => {
    if (a.erledigt !== b.erledigt) return a.erledigt ? 1 : -1;
    const dA = a.faelligkeitsdatum || '9999-12-31';
    const dB = b.faelligkeitsdatum || '9999-12-31';
    if (dA !== dB) return dA < dB ? -1 : 1;
    return prioMeta(a.prioritaet).rang - prioMeta(b.prioritaet).rang;
  });

/** Fortschritt der Unteraufgaben als { erledigt, gesamt }. */
export const unteraufgabenFortschritt = (todo) => {
  const gesamt = todo.unteraufgaben?.length ?? 0;
  const erledigt = todo.unteraufgaben?.filter((u) => u.erledigt).length ?? 0;
  return { erledigt, gesamt };
};
